/* eslint-disable no-console */
import React from 'react';
import { connect } from 'react-redux';
import * as pathSelectors from '../../selectors/pathViewer';

const PathProgress = props => (
  <div className="PathProgress">
    <div
      className="PathProgress-bar"
      style={{
        width: `${props.completedPercentage}%`,
      }}
    />
  </div>
);

const mapStateToProps = state => ({
  completedPercentage:
    typeof state.pathViewer.percentComplete === 'number'
      ? state.pathViewer.percentComplete
      : pathSelectors.completedPercentage(state),
});

export default connect(mapStateToProps)(PathProgress);
